<template>
  <div class="main__section">
    <h1 class="section__title">
      {{ $t('settings-1') }}
    </h1>
    <div class="main__body">
      <div class="form-body">
        <h1 class="group__title">
          {{ $t('language') }}
        </h1>
        <div class="form-row">
          <select class="custom-select small" @change="setLanguage" v-model="language">
            <option value="ru">{{ $t('russian') }}</option>
            <option value="en">{{ $t('english') }}</option>
          </select>
        </div>
      </div>
      <div class="form-body">
        <h1 class="group__title">
          {{ $t('connect-email') }}
        </h1>
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">№</th>
            <th scope="col">Email</th>
            <th scope="col">SMTP</th>
            <th scope="col">{{ $t('password') }}</th>
            <th scope="col">SSL</th>
            <th scope="col">{{ $t('status') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in allMails" v-bind:key="item.id">
            <th scope="row">
              {{ index + 1}}
            </th>
            <td>{{ item.login }}</td>
            <td>{{ item.smtp }}</td>
            <td>{{ item.password }}</td>
            <td>{{ Boolean(item.ssl) }}</td>
            <td class="active" v-if="item.active">{{ $t('active-1') }}</td>
            <td class="unactive" v-else>{{ $t('no-active') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="form-row mt-1">
        <a class="btn btn-primary" @click="showCreateEmailModal">{{ $t('add-email') }}</a>
      </div>
      <div class="form-body">
        <h1 class="group__title">
          {{ $t('connect-name-for-sms') }}
        </h1>
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">№</th>
            <th scope="col">{{ $t('name') }}</th>
            <th scope="col">{{ $t('status') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in allSms" v-bind:key="item.id">
            <th scope="row">
              {{ index + 1}}
            </th>
            <td>{{ item.name }}</td>
            <td class="active" v-if="item.confirm">{{ $t('active-1') }}</td>
            <td class="unactive" v-else>{{ $t('no-active') }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="form-row mt-1">
        <a class="btn btn-primary" @click="showCreateSmsNameModal">{{ $t('add-name') }}</a>
      </div>

      <div class="form-body">
        <h1 class="group__title">
          {{ $t('register-url') }}
        </h1>
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">№</th>
            <th scope="col">{{ $t('named') }}</th>
            <th scope="col">{{ $t('url') }}</th>
            <th scope="col">{{ $t('commentary') }}</th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in allUrls" v-bind:key="item.id">
            <th scope="row">
                {{ index + 1}}
            </th>
            <td>{{ item.name }}</td>
            <td>{{ item.short_link }}</td>
            <td>{{ item.comment }}</td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="form-row mt-1">
        <a class="btn btn-primary" @click="showCreateUrlModal">{{ $t('add-url') }}</a>
      </div>

      <div class="form-body">
        <h1 class="group__title">
          {{ $t('dynamic-field') }}
        </h1>
        <table class="table table-striped">
          <thead>
          <tr>
            <th scope="col">№</th>
            <th scope="col">{{ $t('named') }}</th>
            <th scope="col">{{ $t('key') }}</th>
            <th scope="col">{{ $t('type') }} {{ $t('field').toLowerCase() }}</th>
            <th scope="col">{{ $t('commentary') }}</th>
            <th scope="col"></th>
          </tr>
          </thead>
          <tbody>
          <tr v-for="(item, index) in allFields" v-bind:key="item.id">
            <th scope="row">
              {{ index + 1}}
            </th>
            <td>{{ item.name }}</td>
            <td>{{ item.name_key }}</td>
            <td v-if="item.type_field == 0">{{ $t('string') }}</td>
            <td v-else-if="item.type_field == 1">{{ $t('number') }}</td>
            <td v-else>{{ $t('date') }}</td>
            <td>{{ item.comment }}</td>
            <td>
              <label class="table__td-trash pointer" @click="deleteAccept(item.id, item.name)">
                <img src="@/assets/icon/trash.svg">
              </label>
            </td>
          </tr>
          </tbody>
        </table>
      </div>
      <div class="form-row mt-1">
        <a class="btn btn-primary" @click="showCreateFieldModal">{{ $t('add-field') }}</a>
      </div>

    </div>

    <create-user-email v-show="isModalUserEmailVisible"
                        @close="closeCreateEmailModal"/>
    <create-user-sms-name v-show="isModalSmsNameVisible"
                       @close="closeCreateSmsNameModal"/>
    <create-user-url v-show="isModalUrlVisible"
                     @close="closeCreateUrlModal"/>
    <create-dynamic-field v-show="isModalFieldVisible"
                      @close="closeCreateFieldModal"/>
    <remove-dynamic-field-modal :field="deleteField" v-show="isModalDeleteFieldVisible"
                                @close="closeDeleteFieldModal"/>
  </div>
</template>

<script>
import CreateUserEmail from "../../components/modal/createUserEmail";
import CreateUserSmsName from "../../components/modal/createUserSmsName";
import { mapGetters } from 'vuex';
import language from "../../i18n";
import CreateUserUrl from "../../components/modal/createUserUrl";
import CreateDynamicField from "../../components/modal/createDynamicField";
import RemoveDynamicFieldModal from "../../components/modal/settings/remove-dynamic-field-modal";
export default {
  name: 'settings',
  data: function(){
    return{
      language: this.$store.state.language,
      isModalUserEmailVisible: false,
      isModalSmsNameVisible: false,
      isModalUrlVisible: false,
      isModalFieldVisible: false,
      isModalDeleteFieldVisible: false,
      deleteField: {
        id: 0,
        name: ''
      }
    }
  },
  computed: mapGetters(['allMails', 'allSms', 'allUrls', 'allFields']),
  async mounted() {
    this.$store.dispatch('fetchMails');
    this.$store.dispatch('fetchSms');
    this.$store.dispatch('fetchUrls');
    this.$store.dispatch('fetchFields');
    this.checkVerifyMail();
  },
  methods: {
    deleteAccept: function(id, name){
      this.deleteField.id = id;
      this.deleteField.name = name;
      this.showDeleteFieldModal();
    },
    checkVerifyMail: function(){
      let token = this.$route.params.token;
      if(token){
        this.$store.dispatch('verifyToken', token).then(response => {
          if (response.status) {
            this.$store.dispatch('fetchMails');
            this.$toast.success("Почта успешно активирована");
          }
        }).catch(error => {
          console.log(error);
        });
      }
    },
    setLanguage: function(){
      this.$store.state.language = this.language;
      language.locale = this.language;
    },
    showCreateSmsNameModal() {
      this.isModalSmsNameVisible = true;
    },
    closeCreateSmsNameModal() {
      this.isModalSmsNameVisible = false;
    },
    showCreateEmailModal() {
      this.isModalUserEmailVisible = true;
    },
    closeCreateEmailModal() {
      this.isModalUserEmailVisible = false;
    },
    showCreateUrlModal() {
      this.isModalUrlVisible = true;
    },
    closeCreateUrlModal() {
      this.isModalUrlVisible = false;
    },
    showCreateFieldModal() {
      this.isModalFieldVisible = true;
    },
    closeCreateFieldModal() {
      this.isModalFieldVisible = false;
    },
    showDeleteFieldModal() {
      this.isModalDeleteFieldVisible = true;
    },
    closeDeleteFieldModal() {
      this.isModalDeleteFieldVisible = false;
    },
  },
  components: {
    RemoveDynamicFieldModal,
    CreateDynamicField,
    CreateUserUrl,
    CreateUserEmail, CreateUserSmsName
  }
}
</script>